import { FC } from 'react'
import createStandardIcon from './createStandardIcon'
import type { IconProps } from './type'

const PaymentsIconSvg: FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} height="20px" viewBox="0 -960 960 960" width="20px" fill="black">
      <path d="M542-443.54q-41.92 0-70.96-29.04Q442-501.62 442-543.54q0-41.92 29.04-70.96 29.04-29.04 70.96-29.04 41.92 0 70.96 29.04Q642-585.46 642-543.54q0 41.92-29.04 70.96-29.04 29.04-70.96 29.04Zm-271.85 99.85q-26.52 0-45.41-18.91-18.89-18.91-18.89-45.46v-271.29q0-26.55 18.89-45.29t45.41-18.74h543.69q26.53 0 45.42 18.9 18.89 18.91 18.89 45.46v271.3q0 26.55-18.89 45.29t-45.42 18.74H270.15Zm52-52h439.7q0-26.92 18.89-45.73 18.89-18.81 45.41-18.81v-166.85q-26.62 0-45.46-18.89t-18.84-45.41h-439.7q0 26.92-18.89 45.73-18.89 18.8-45.41 18.8V-460q26.62 0 45.46 18.89t18.84 45.42Zm436.77 176H146.16q-26.53 0-45.42-18.89T81.85-284v-364.15h52V-284q0 4.61 3.84 8.46 3.85 3.85 8.47 3.85h612.76v52Zm-488.77-176h-12.3V-691.38h12.3q-5 0-8.65 3.65-3.65 3.65-3.65 8.65V-408q0 5 3.65 8.65 3.65 3.66 8.65 3.66Z" />
    </svg>
  )
}

export const PaymentsIcon = createStandardIcon(PaymentsIconSvg)
